<template>
  <!-- Typical User -->
  <div
    @click="toggleProfileOverlay"
    :class="{ profile_badge: userType == 'general' }"
  >
    <h4 v-if="userType == 'general'">
      {{ userPoints
      }}<span style="font-size: 0.7em">{{
        userPoints == 1 ? "pt" : "pts"
      }}</span>
    </h4>
    <ProfileImage
      v-if="!profilePicture"
      :label="profileInitials"
      class="mr-2 profile_initials profile_btn"
      shape="circle"
    />
    <ProfileImage
      v-else
      :image="profilePicture"
      class="mr-2 profile_image profile_btn"
      shape="circle"
    />
  </div>
  <!-- Drop Down Menu -->
  <OverlayPanel ref="profileol" width="300px">
    <div class="top_nav_sub_menu">
      <h3>
        {{
          userType == "customer"
            ? companyName
            : usersName.firstName + " " + usersName.lastName
        }}
      </h3>
      <span class="body_copy_s grey_font">{{
        userType == "customer"
          ? usersName.firstName + " " + usersName.lastName
          : companyName
      }}</span>
      <div v-if="userType == 'general'" class="point_item">
        <img
          :src="require('@/assets/icons/icon-peaki-points.svg')"
          style="width: 20px"
        />
        <h3>
          {{ userPoints
          }}<span style="font-size: 0.7em">{{
            userPoints == 1 ? "pt" : "pts"
          }}</span>
        </h3>
      </div>
      <hr class="divider_line" />
      <router-link :to="{ name: 'account-general' }">
        <div class="top_nav_list_menu" @click="closeOverlay()">
          {{ $t("profile.general") }}
        </div>
      </router-link>
      <router-link
        :to="{ name: 'account-locations' }"
        v-if="userType == 'customer'"
      >
        <div class="top_nav_list_menu" @click="closeOverlay()">
          {{ $t("profile.locations") }}
        </div>
      </router-link>
      <router-link
        :to="{ name: 'account-departments' }"
        v-if="userType == 'customer'"
      >
        <div class="top_nav_list_menu" @click="closeOverlay()">
          {{ $t("profile.departments") }}
        </div>
      </router-link>
      <router-link
        :to="{ name: 'account-users' }"
        v-if="userType == 'customer'"
      >
        <div class="top_nav_list_menu" @click="closeOverlay()">
          {{ $t("profile.users") }}
        </div>
      </router-link>
      <router-link
        :to="{ name: 'billing-and-payments' }"
        v-if="userType == 'customer'"
      >
        <div class="top_nav_list_menu" @click="closeOverlay()">
          {{ $t("profile.billing_and_payments") }}
        </div>
      </router-link>
      <router-link
        :to="{ name: 'account-integrations' }"
        v-if="userType == 'customer'"
      >
        <div class="top_nav_list_menu" @click="closeOverlay()">
          {{ $t("integrations.integrations") }}
        </div>
      </router-link>
      <hr class="divider_line" />
      <router-link :to="{ name: 'legal-and-policies' }">
        <div class="top_nav_list_menu" @click="closeOverlay()">
          {{ $t("profile.legal_and_policies") }}
        </div>
      </router-link>
      <hr class="divider_line" />
      <div class="top_nav_list_menu" @click="logOut()">
        {{ $t("global.log_out") }}
      </div>
    </div>
  </OverlayPanel>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    countryCode: {
      type: String,
      default: "GLOBAL",
    },
  },
  computed: {
    ...mapGetters("userData", [
      "usersName",
      "companyName",
      "profileInitials",
      "profilePicture",
      "userType",
      "userPoints",
    ]),
  },
  methods: {
    // Toggles the Overlay Dialog to show/hide
    toggleProfileOverlay(event) {
      this.$refs.profileol.toggle(event);
    },
    // Closes the overlay
    closeOverlay() {
      this.$refs.profileol.hide();
    },
    // Logs the user out of the application via Auth0
    logOut() {
      this.authLogOut();
      this.$auth0.logout();
      window.localStorage.removeItem("vuex");
    },
    ...mapActions(["authLogOut"]),
  },
};
</script>

<style scoped>
.profile_line {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: var(--border-radius);
  cursor: pointer;
}
.profile_line:hover {
  background: var(--grey-light);
}

.profile_badge {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0px 0px 0px 15px;
  height: fit-content;
  margin-top: 4px;
  margin-right: 10px;
  border-radius: 20px;
  cursor: pointer;
  background: var(--blue-light);
}

.point_item {
  padding: 8px 15px;
  margin-top: 15px;
  margin-bottom: 20px;
  border-radius: var(--border-radius);
  background: var(--accent);
  display: flex;
  gap: 5px;
}
</style>
